import React, { useMemo } from 'react'

import { PREFERENCES } from '../../user/constants'

import {
  useIncidentsFetch,
  usePalmettoIncidentsFetch,
  useEventTypesFetch,
} from '../../palmetto/hooks'
import { useCrimeCategoriesFetch } from '../../crimeCategories/hooks'
import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'

import IncidentPanel from '../../palmetto/components/IncidentPanel'
import PalmettoIncidentLayer from '../../map/components/PalmettoIncidentLayer'
import UserPanel from '../../user/components/UserPanel'
import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import BasemapToggle from '../../map/components/BasemapToggle'
import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'
import MapDataToggle from '../../mobile/components/MapDataToggle'
import MobileSidebar from '../../mobile/components/MobileSidebar'
import MobileBaseLayout from '../../mobile/components/MobileBaseLayout'
import MobileSiteSwitcher from '../../mobile/components/MobileSiteSwitcher'

const tabs = [
  { name: 'User Options', icon: 'fa fa-user', url: '/palmetto/userMenu' },
  {
    name: 'Incident List',
    icon: 'fa fa-list-ul',
    url: '/palmetto/incidentList',
  },
]

const MobileLayout = () => {
  useIncidentsFetch() // Run the incident fetch loop
  useCrimeCategoriesFetch() // fetch the list of crime categories
  usePalmettoIncidentsFetch() // fetch incidents from palmetto system
  useEventTypesFetch() // fetch event types
  useUserPreferencesFetch() // fetch user's preferences

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      bottom: 75,
    }),
    []
  )

  return (
    <MobileBaseLayout title="Palmetto" basePath="/palmetto">
      <MobileSidebar basePath="/palmetto">
        <TabPanelContainer>
          <TabPanel path="/palmetto/menu">
            <MobileSiteSwitcher tabs={tabs} />
          </TabPanel>
          <TabPanel path="/palmetto/userMenu" component={UserPanel} />
          <TabPanel path="/palmetto/incidentList" component={IncidentPanel} />
        </TabPanelContainer>
      </MobileSidebar>
      <MapDataToggle mapPath="/palmetto/" listPath="/palmetto/incidentList" />
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <Zoom position="none" />
        <PalmettoIncidentLayer />
      </Map>
    </MobileBaseLayout>
  )
}

export default MobileLayout
